export default __webpack_public_path__ + "static/media/chevy.388a5de4.png";